import React from "react";
import RevealSection from "../RevealSection";

export const Problem = () => {
  return (
    <section
      data-testid="problem-section"
      style={{ background: "white", padding: "100px 24px", textAlign: "center" }}
    >
      <RevealSection>
        <p
          className="font-body"
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#1D9E75",
            marginBottom: 16,
          }}
        >
          THE PROBLEM
        </p>
      </RevealSection>

      <RevealSection>
        <h2
          className="font-heading"
          style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 700, letterSpacing: "-1px", lineHeight: 1.1, color: "#1a1a18", marginBottom: 8 }}
        >
          Job boards show you jobs.
        </h2>
      </RevealSection>

      <RevealSection delay={1}>
        <h2
          className="font-heading"
          style={{ fontSize: "clamp(28px, 4vw, 46px)", fontWeight: 700, color: "#1D9E75" }}
        >
          Nobody tells you which ones are worth your time.
        </h2>
      </RevealSection>

      <RevealSection delay={2}>
        <p
          className="font-body"
          style={{
            fontSize: 17,
            color: "#5f5e5a",
            lineHeight: 1.7,
            maxWidth: 560,
            margin: "24px auto 0",
          }}
        >
          Postings open for months. Roles already filled internally. Companies about to do
          layoffs. JDs that don't match your seniority. You find out after wasting hours.
        </p>
      </RevealSection>
    </section>
  );
};

export default Problem;
